<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>
<!-- Milestone announcements only (start, 30/15/10/5/1 min, 30 s, end); the visible clock is not read every second. -->
<div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ timerAnnouncement }}</div>

<app-mock-subscription
  *ngIf="!isSpinner && subscriptionRequired"
  [keepAnswers]="!!attempt"
></app-mock-subscription>

<ng-container *ngIf="!isSpinner && attempt as exam">
<div class="exam-page" *ngIf="currentQuestion as question">
  <div class="exam-toolbar">
    <div class="time-block" [class.is-low]="remainingMs > 0 && remainingMs < 300000">
      <span class="time-caption" id="mock-time-caption">{{ 'mockRemaining' | translate }}</span>
      <span class="time-value" role="timer" aria-live="off" aria-labelledby="mock-time-caption">{{ remainingLabel }}</span>
    </div>
    <div class="toolbar-meta">
      <span class="paper-pill">Paper {{ exam.paper }}</span>
      <span class="question-count">
        {{ 'question' | translate }} {{ state.currentIndex + 1 }} {{ 'demoOf' | translate }} {{ exam.questions.length }}
      </span>
      <span class="paper-line">
        Paper {{ exam.paper }} · {{ 'question' | translate }} {{ state.currentIndex + 1 }}/{{ exam.questions.length }}
      </span>
    </div>
    <button type="button" class="primary-button submit-button" [disabled]="submitting || subscriptionRequired" (click)="openSubmit()">
      <span class="submit-full">{{ 'mockSubmit' | translate }}</span>
      <span class="submit-short">{{ 'mockSubmitShort' | translate }}</span>
    </button>
  </div>

  <p class="form-error" *ngIf="timeUp">{{ 'mockTimeUp' | translate }}</p>
  <p class="form-error" *ngIf="submitError && !subscriptionRequired">{{ 'mockSubmitError' | translate }}</p>

  <div class="exam-layout">
    <section class="question-panel">
      <p class="area-kicker">{{ question.area_label }}</p>
      <div class="question-text">
        <span class="question-id">{{ state.currentIndex + 1 }}.</span>
        <span>{{ question.question_text }}</span>
      </div>
      <div class="question-image-wrapper" *ngIf="question.image">
        <img [src]="question.image" alt="" />
      </div>

      <div class="statement" *ngFor="let option of question.options">
        <div class="statement-text">
          <span class="option-letter-circle" aria-hidden="true">{{ letter(option.index) }}</span>
          <span [id]="'statement-' + option.index">{{ option.text }}</span>
        </div>
        <div class="tf-row" role="group" [attr.aria-label]="statementLabel(option)">
          <button
            type="button"
            class="tf-button"
            [class.is-selected]="answerFor(question, option.index) === true"
            [attr.aria-pressed]="answerFor(question, option.index) === true"
            (click)="choose(question, option.index, true)"
          >
            <span class="tf-mark" aria-hidden="true" *ngIf="answerFor(question, option.index) === true">&#10003;</span>{{ 'mockTrue' | translate }}
          </button>
          <button
            type="button"
            class="tf-button"
            [class.is-selected]="answerFor(question, option.index) === false"
            [attr.aria-pressed]="answerFor(question, option.index) === false"
            (click)="choose(question, option.index, false)"
          >
            <span class="tf-mark" aria-hidden="true" *ngIf="answerFor(question, option.index) === false">&#10003;</span>{{ 'mockFalse' | translate }}
          </button>
        </div>
      </div>

      <div class="exam-actions">
        <button type="button" class="ghost-button" [disabled]="state.currentIndex === 0" (click)="previous()">
          <i nz-icon nzType="left"></i>{{ 'previous' | translate }}
        </button>
        <button
          type="button"
          class="ghost-button flag-button"
          [class.is-on]="isFlagged(question)"
          [attr.aria-pressed]="isFlagged(question)"
          (click)="toggleFlag()"
        >
          {{ 'mockFlag' | translate }}
        </button>
        <button
          type="button"
          class="ghost-button"
          [disabled]="state.currentIndex >= exam.questions.length - 1"
          (click)="next()"
        >
          {{ 'next' | translate }}<i nz-icon nzType="right"></i>
        </button>
      </div>
    </section>

    <aside class="navigator-panel">
      <button type="button" class="nav-toggle" (click)="navOpen = !navOpen" [attr.aria-expanded]="navOpen">
        <span class="nav-toggle-label">{{ navigatorSummary() }}</span>
      </button>
      <div class="navigator" [class.is-open]="navOpen">
        <ul class="nav-legend">
          <li><i class="swatch is-answered" aria-hidden="true">&#10003;</i>{{ 'mockAnswered' | translate }}</li>
          <li><i class="swatch is-partial" aria-hidden="true">&#9680;</i>{{ 'mockPartial' | translate }}</li>
          <li><i class="swatch is-flagged" aria-hidden="true">&#9873;</i>{{ 'mockFlagged' | translate }}</li>
          <li><i class="swatch is-unanswered"></i>{{ 'unanswered' | translate }}</li>
        </ul>
        <div class="nav-grid">
          <button
            type="button"
            class="nav-cell"
            *ngFor="let item of exam.questions; let i = index"
            [class.is-current]="i === state.currentIndex"
            [class.is-answered]="progressOf(item) === 'answered'"
            [class.is-partial]="progressOf(item) === 'partial'"
            [class.is-unanswered]="progressOf(item) === 'unanswered'"
            [class.is-flagged]="isFlagged(item)"
            [attr.aria-current]="i === state.currentIndex ? 'true' : null"
            [attr.aria-label]="navCellLabel(item, i)"
            (click)="goTo(i)"
          >
            {{ i + 1 }}
            <span class="nav-mark" aria-hidden="true">{{ navMark(item) }}</span>
          </button>
        </div>
      </div>
    </aside>
  </div>

  <nav class="mobile-dock" [attr.aria-label]="'mockNavigator' | translate">
    <button type="button" class="ghost-button" [disabled]="state.currentIndex === 0" (click)="previous()">
      <i nz-icon nzType="left"></i>{{ 'previous' | translate }}
    </button>
    <button
      type="button"
      class="ghost-button flag-button"
      [class.is-on]="isFlagged(question)"
      [attr.aria-pressed]="isFlagged(question)"
      (click)="toggleFlag()"
    >
      {{ 'mockFlag' | translate }}
    </button>
    <button
      type="button"
      class="ghost-button"
      [disabled]="state.currentIndex >= exam.questions.length - 1"
      (click)="next()"
    >
      {{ 'next' | translate }}<i nz-icon nzType="right"></i>
    </button>
  </nav>
</div>
</ng-container>

<p class="form-error load-error" *ngIf="!isSpinner && loadError && !subscriptionRequired">{{ 'mockLoadError' | translate }}</p>

<ng-template #submitConfirm>
  <p class="submit-count">{{ 'unanswered' | translate }}: {{ pendingCounts.unanswered }}</p>
  <p class="submit-count">{{ 'mockPartial' | translate }}: {{ pendingCounts.partial }}</p>
  <p class="submit-count">{{ 'mockFlagged' | translate }}: {{ pendingCounts.flagged }}</p>
</ng-template>
